$mapHas